import {atom} from 'jotai';

const flattedMenusAtom = atom([]);

export {flattedMenusAtom};
